import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    items: [],
    cartCountHighlight: false,
};

const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        // Add item to cart or update quantity if exists
        addToCart: (state, action) => {
            const { product, qty } = action.payload;
            const productImage = product.image || product.image_url || product.imageUrl || null;
            const existingIndex = state.items.findIndex(
                (item) => item.productId === product.id
            );

            if (existingIndex !== -1) {
                // Update existing item quantity
                const newQty = state.items[existingIndex].qty + qty;
                if (newQty <= 0) {
                    state.items.splice(existingIndex, 1);
                    return;
                }
                state.items[existingIndex].qty = newQty;
                state.items[existingIndex].stock = product.stock;
                state.items[existingIndex].image = productImage || state.items[existingIndex].image || null;
            } else {
                // Add new item
                state.items.push({
                    lineId: Date.now(),
                    productId: product.id,
                    name: product.name,
                    price: product.price,
                    stock: product.stock,
                    image: productImage,
                    qty,
                });
            }
        },

        // Remove item from cart or decrease quantity
        removeFromCart: (state, action) => {
            const { lineId, removeAll } = action.payload;
            const index = state.items.findIndex((item) => item.lineId === lineId);

            if (index !== -1) {
                if (removeAll || state.items[index].qty <= 1) {
                    state.items.splice(index, 1);
                } else {
                    state.items[index].qty -= 1;
                }
            }
        },

        // Update cart item with new values
        updateCartItem: (state, action) => {
            const { lineId, updates } = action.payload;
            const item = state.items.find((item) => item.lineId === lineId);
            if (item) {
                Object.assign(item, updates);
            }
        },

        // Clear entire cart
        clearCart: (state) => {
            state.items = [];
        },

        // Restore cart from localStorage (used on rehydrate)
        restoreCart: (state, action) => {
            state.items = action.payload || [];
        },

        // Trigger cart badge highlight animation
        bumpCartCount: (state) => {
            state.cartCountHighlight = true;
        },

        // Reset highlight state
        resetCartHighlight: (state) => {
            state.cartCountHighlight = false;
        },
    },
});

export const {
    addToCart,
    removeFromCart,
    updateCartItem,
    clearCart,
    restoreCart,
    bumpCartCount,
    resetCartHighlight,
} = cartSlice.actions;

export default cartSlice.reducer;
